"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBugErrorMessage = void 0;
/**
 * @since 2.0.0
 */
/** @internal */
const getBugErrorMessage = message => `BUG: ${message} - please report an issue at https://github.com/Effect-TS/effect/issues`;
exports.getBugErrorMessage = getBugErrorMessage;
//# sourceMappingURL=errors.js.map